import type { SelectFc } from '@app/types/QueryOptions'
import type { FilterOption } from '@app/types/filter'
import type { ExternalProductsCatalogDataSource } from '@app/pages/ExternalProductsCatalogPage/types'

export const getMergeProductsSelectOptions: SelectFc<FilterOption, ExternalProductsCatalogDataSource> = response =>
  response?.map(({ key, name }) => ({
    value: key,
    label: `${key} ${name ?? ''}`
  })) ?? []
